import { Link } from "react-router-dom";
import { STEPS } from "../data/content";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

export default function Timeline({ showHeader = true, seamless = false }) {
  const { lang, t } = useLang();

  return (
    <section
      className={`relative py-24 sm:py-32 overflow-hidden ${
        seamless ? "" : "bg-navy"
      }`}
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        {showHeader && (
          <Reveal className="text-center mb-20">
            <Overline>{t.timeline.overline}</Overline>
            <h2 className="font-serif text-4xl sm:text-5xl font-bold mt-4">
              {t.timeline.titleA}{" "}
              <span className="text-gold-gradient">{t.timeline.accent}</span>
            </h2>
            <p className="mt-5 text-muted2 max-w-xl mx-auto">{t.timeline.body}</p>
          </Reveal>
        )}

        <div className="relative">
          {/* center gold line */}
          <div className="absolute left-6 md:left-1/2 top-2 bottom-2 w-px bg-gradient-to-b from-gold/0 via-gold/60 to-gold/0 md:-translate-x-1/2" />

          <div className="space-y-14">
            {STEPS.map((step, i) => {
              const Icon = step.icon;
              const left = i % 2 === 0;
              return (
                <Reveal key={step.title.en} delay={0.05 * i}>
                  <div
                    data-testid={`timeline-step-${i + 1}`}
                    className="relative flex md:items-center"
                  >
                    {/* node */}
                    <div className="absolute left-6 md:left-1/2 md:-translate-x-1/2 -translate-x-1/2 z-10">
                      <div className="h-12 w-12 rounded-full bg-deepblack border border-gold/50 flex items-center justify-center text-gold font-serif text-lg shadow-[0_0_24px_rgba(201,168,76,0.25)]">
                        {i + 1}
                      </div>
                    </div>

                    {/* card */}
                    <div
                      className={`pl-20 md:pl-0 w-full md:w-1/2 ${
                        left
                          ? "md:pr-16 md:text-right md:mr-auto"
                          : "md:pl-16 md:ml-auto"
                      }`}
                    >
                      <div className="bg-deepblack border border-gold/20 p-7 hover:border-gold/50 transition-colors duration-300">
                        <div
                          className={`flex items-center gap-3 mb-3 ${
                            left ? "md:justify-end" : ""
                          }`}
                        >
                          <Icon size={20} className="text-gold" />
                          <span className="uppercase tracking-[0.2em] text-[11px] text-gold font-semibold">
                            {t.timeline.step} {i + 1}
                          </span>
                        </div>
                        <h3 className="font-serif text-2xl text-offwhite mb-2">
                          {step.title[lang]}
                        </h3>
                        <p className="text-sm text-muted2 leading-relaxed">
                          {step.desc[lang]}
                        </p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        {showHeader && (
          <Reveal className="text-center mt-20">
            <Link
              to="/contact"
              data-testid="timeline-cta"
              className="inline-block bg-gold text-deepblack px-9 py-3.5 text-xs font-semibold uppercase tracking-[0.15em] hover:bg-goldhover transition-colors"
            >
              {t.timeline.cta}
            </Link>
          </Reveal>
        )}
      </div>
    </section>
  );
}
